import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export class MultiTranslateHttpLoader implements TranslateLoader {
  /**
   * @param http Instance of an HTTP instance
   * @param resources Array of objects with the desire languages assets
   **/
  constructor(
    private http: HttpClient,
    private resources: object[]
  ) { }

  /**
   * @method getTranslation is a implementation of the TranslateLoader class so
   * we ca be able to set more than one languge form different JSON's
   **/
  public getTranslation(lang: string): Observable<object> {
    const cacheBuster = new Date().getTime();
    const requests = this.resources.map(resource => {
      return this.http.get(`${resource['prefix']}${lang}${resource['suffix']}?v=${cacheBuster}`);
    });
    return forkJoin(requests).pipe(map(response => response.reduce((a, b) => Object.assign(a, b))));
  }
}
